import React from "react";
import { Trash2, X } from "lucide-react";
import { Dialog, DialogContent } from "components/ui/dialog";
import { Button } from "components/ui/button";

const EquipmentDeleteConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  equipmentName, // Add this prop
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        className={`
          fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2
          max-w-[420px] w-full
          rounded-2xl
          border-none
          dark:border dark:border-zinc-800
          shadow-xl
          p-0
          bg-white dark:bg-black-primary
          ${isOpen ? "animate-center-slide-up" : "animate-center-slide-down"}
        `}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 dark:hover:text-zinc-300 transition-colors z-50"
        >
          <X size={18} />
        </button>

        {/* Content Container */}
        <div className="p-8">
          {/* Icon */}
          <div className="w-12 h-12 rounded-full bg-red-50 dark:bg-red-900/20 border border-red-100 dark:border-red-900/30 flex items-center justify-center mb-5">
            <Trash2 className="text-red-500" size={22} />
          </div>

          {/* Title - Shows Equipment Name */}
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
            Delete {equipmentName}?
          </h2>

          {/* Description - Shows Equipment Name */}
          <p className="text-sm text-gray-500 dark:text-zinc-400 mt-2">
            Are you sure you want to remove <span className="font-medium text-gray-700 dark:text-zinc-200">"{equipmentName}"</span> from your inventory? This action cannot be undone.
          </p>

          {/* Actions */}
          <div className="flex gap-3 mt-8">
            <Button
              variant="ghost"
              onClick={onClose}
              className="
                flex-1
                bg-gray-100 dark:bg-zinc-800
                hover:bg-gray-200 dark:hover:bg-zinc-700
                text-gray-700 dark:text-zinc-200
                h-11
                rounded-xl
                font-medium
                border-none
              "
            >
              Cancel
            </Button>

            <Button
              onClick={onConfirm}
              className="
                flex-1
                bg-red-500
                hover:bg-red-600
                text-white
                h-11
                rounded-xl
                font-medium
                flex
                items-center
                justify-center
                gap-2
                border-none
                shadow-md dark:shadow-none
              "
            >
              <Trash2 size={16} />
              Delete
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default EquipmentDeleteConfirmationModal;
